import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import stickySidebar from 'sticky-sidebar';

import { DataMaterialsService }  from '@components/materials/data-materials.service';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-global-materials',
  templateUrl: './global-materials.component.html',
  styleUrls: ['./global-materials.component.less']
})
export class GlobalMaterialsComponent implements OnInit {

  public currentProject: any;
  public projectSubscription: Subscription;
  public isLoaded:boolean = false;
  public screenHeight: number;
  public screenWidth: number;
  public routeObs$;
  public activeRoute = 'listing';

  constructor(
    private globalDataService: GlobalDataService,
    private requestV2Service: RequestV2Service,
    private dataMaterialsService: DataMaterialsService,
    private router: Router
  ) {
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  async ngOnInit() {
    this.routeObs$ = this.router.events.subscribe((val:any) => {
      const routes = ['listing', 'version', 'alternative'];

      this.activeRoute = routes.find((r:any) => {
        if (val.url) {
          return val.url.includes(r);
        }

        return null;
      });
    });

    await this.initProjectAndMaterials();

    if (this.screenWidth > 767) {
      this.createStickyBar();
    }
  }

  private async initProjectAndMaterials() {
    // Disabled general loader from creativity only on this first fetch
    const globalLoader = document.getElementById('circle-container');

    if (globalLoader) {
      globalLoader.style.display = 'none';
    }

    this.dataMaterialsService.refreshData = true;
    this.projectSubscription = this.globalDataService
      .getCurrentProject()
      .subscribe(async (project:any) => {
        if (!project || !this.dataMaterialsService.refreshData) {
          return;
        }

        // Set Projects
        this.currentProject = project;
        this.dataMaterialsService.currentProject = project;
        this.dataMaterialsService.refreshData = false;

        await this.dataMaterialsService.computeQuotationMaterialsData();

        this.isLoaded = true;
      });
  }

  ngOnDestroy() {
    if (this.routeObs$) {
      this.routeObs$.unsubscribe();
    }
  }

  createStickyBar() {
    new stickySidebar('#sidebar', {
      topSpacing: 0,
      bottomSpacing: 20,
      resizeSensor: true,
      containerSelector: '.global-material-root',
      stickyClass: 'is-affixed',
      innerWrapperSelector: '.container-navbar'
    });
  }
}
